import { Box, Grid, Typography } from '@mui/material';
import Iconify from 'src/components/iconify';

export default function DashboardHeader({ Title }) {

  return (
    <>
      <Grid container spacing={2} mt={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 1,  overflow: "hidden" }}>
            <Box sx={{ marginTop: "3px" }}>
              <Iconify icon="ion:home" />
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>

            <Typography variant='h5' sx={{ 
                fontSize: '1.80rem', 
                fontWeight: 300,     
              }} >{Title}
            </Typography>

           
            </Box>

          </Box>
        </Grid>
      </Grid>
    </>
  );
}
